import "@fortawesome/fontawesome-free/css/all.css";
import "@general-backoffice/core/lib/assets/vendor/nucleo/css/nucleo.css";
import "@splidejs/react-splide/css";
import "./styles/styles.css";
import "moment/locale/es";
import "./i18n";

import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import moment from "moment";
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import patchDomForTranslate from "./utils/patchDomForTranslate";

patchDomForTranslate();

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);

moment.locale("es");

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
